'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject_es = require('../lib/style-inject/dist/style-inject.es.js');

var css_248z = ".Modal-module_dialogOverlay__S2FzK{background:#2222228a;z-index:1000}.Modal-module_dialogContent__viy6b{background-color:initial;border-radius:8px;margin:100px auto;max-width:unset;padding:0}.Modal-module_width-defualt__VAgcu{width:42.5rem}.Modal-module_width-small__FT6yV{width:25vw}.Modal-module_width-medium__ENfaO{width:50vw}.Modal-module_width-large__G8q6Z{width:75vw}";
var styles = {"dialogOverlay":"Modal-module_dialogOverlay__S2FzK","dialogContent":"Modal-module_dialogContent__viy6b","width-defualt":"Modal-module_width-defualt__VAgcu","width-small":"Modal-module_width-small__FT6yV","width-medium":"Modal-module_width-medium__ENfaO","width-large":"Modal-module_width-large__G8q6Z"};
styleInject_es["default"](css_248z);

exports["default"] = styles;
//# sourceMappingURL=Modal.module.scss.js.map
